"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// @ts-ignore
const styles_1 = require("@material-ui/core/styles");
// @ts-ignore
const core_1 = require("@material-ui/core");
const icons_1 = require("../icons");
const styles = (0, styles_1.createStyles)({
    root: {
        display: 'flex',
        width: '100%',
        height: '86vh',
        background: '#455157',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
    },
    bottomLogo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '14vh',
    },
    contentLeft: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        flex: 1,
        color: '#fff',
        marginRight: 40,
    },
    innerContentLeft: {
        paddingLeft: 50,
    },
    contentRight: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: 1,
        color: '#fff',
        marginLeft: 40,
    },
    button: {
        backgroundColor: '#56ccf2',
        '&:hover': {
            backgroundColor: 'rgba(84, 204, 242, 0.8)',
        },
        color: '#fff',
        fontSize: 16,
    },
    link: {
        color: '#56ccf2',
        fontSize: 16,
    },
    primaryText: {
        fontSize: 81,
        lineHeight: '95px',
    },
    secondaryText: {
        fontSize: 33,
        lineHeight: '43px',
        marginBottom: 25,
    },
});
class ErrorBoundary extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
        this.refreshPage = () => {
            window.location.reload();
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    render() {
        const { classes } = this.props;
        if (this.state.hasError) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.root },
                    react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.contentLeft },
                        react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.innerContentLeft },
                            react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.primaryText }, "hmm."),
                            react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.secondaryText }, "welp... looks like something broke."),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement(core_1.Button, { className: classes === null || classes === void 0 ? void 0 : classes.button, onClick: this.refreshPage }, "Refresh the page"),
                                "\u00A0\u00A0\u00A0OR\u00A0\u00A0\u00A0",
                                react_1.default.createElement(core_1.Link, { href: 'https://terragotech.com/support/submit-support-case/', className: classes === null || classes === void 0 ? void 0 : classes.link }, "Contact Support")))),
                    react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.contentRight },
                        react_1.default.createElement(icons_1.TGErrorIcon, null))),
                react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.bottomLogo },
                    react_1.default.createElement(icons_1.TGLogo, null))));
        }
        return this.props.children;
    }
}
exports.default = (0, styles_1.withStyles)(styles)(ErrorBoundary);
//# sourceMappingURL=ErrorBoundary.js.map